import {
  Rss,
  MessageSquare,
  Radio,
  ImageIcon,
  Globe,
  UserCircle,
  Settings,
  Bell,
  BookOpen,
  Pencil,
  Mail,
  Search,
  FileText,
  type LucideIcon,
} from 'lucide-react';
import type { AppId } from './DesktopContext';

export interface AppMeta {
  id: AppId;
  /** Short name shown in the dock and command palette */
  label: string;
  /** Default window title */
  title: string;
  icon: LucideIcon;
}

/** Canonical metadata for every desktop app, in default dock order. */
export const APP_REGISTRY: AppMeta[] = [
  { id: 'feed', label: 'Feed', title: 'Nostr Feed', icon: Rss },
  { id: 'search', label: 'Search', title: 'Search', icon: Search },
  { id: 'notifications', label: 'Notifications', title: 'Notifications', icon: Bell },
  { id: 'articles', label: 'Articles', title: 'Articles', icon: BookOpen },
  { id: 'mail', label: 'Mail', title: 'Mail', icon: Mail },
  { id: 'dms', label: 'Messages', title: 'Direct Messages', icon: MessageSquare },
  { id: 'media', label: 'Media', title: 'Media Browser', icon: ImageIcon },
  { id: 'documents', label: 'Documents', title: 'Documents', icon: FileText },
  { id: 'nsite', label: 'Browser', title: 'Nsite Browser', icon: Globe },
  { id: 'relays', label: 'Relays', title: 'Relay Manager', icon: Radio },
  { id: 'profile', label: 'Profile', title: 'Profile', icon: UserCircle },
  { id: 'settings', label: 'Settings', title: 'Settings', icon: Settings },
  { id: 'publish', label: 'Publish', title: 'Publish', icon: Pencil },
];

export function getAppMeta(id: AppId): AppMeta | undefined {
  return APP_REGISTRY.find((app) => app.id === id);
}
